<smart-table [headers]="headers"
             [source]="source"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [navigate]="entityPath">
  <ng-template smartTableColumn="id" let-item>
    <td>
      <span class="font-weight-medium">{{ item.id }}</span> <br>
    </td>
  </ng-template>

  <ng-template smartTableColumn="userId" let-item>
    <td>
      <span class="font-weight-medium">{{ item.userId }}</span> <br>
    </td>
  </ng-template>

  <ng-template smartTableColumn="moderator" let-item>
    <td>
        {{ item.moderator?.email }} <br>
        <small class="text-muted" *ngIf="item.moderator">Id: {{ item.moderator.id }}</small>
    </td>
  </ng-template>


  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>


